import { useEffect } from "react";
import { errorNotify } from "../../../shared/notifications";
import { validAccess } from "../token-session";

const DEFAULT_REFRESH_CHECK_INTERVAL_MS = 30000;
const REFRESH_CONNECTION_ERROR = "ارتباط با سرور ناموفق بود. لطفاً دوباره تلاش کنید.";

function hasStoredAccessToken() {
    return Boolean(localStorage.getItem("token"));
}

function useAccessTokenRefreshMonitor(checkIntervalMs) {
    useEffect(() => {
        let isStopped = false;
        let isChecking = false;
        let hasReportedFailure = false;

        function reportRefreshFailure() {
            // Do not notify after unmount or after authentication has been cleared.
            if (isStopped || hasReportedFailure || !hasStoredAccessToken()) return;
            errorNotify(REFRESH_CONNECTION_ERROR);
            hasReportedFailure = true;
        }

        async function checkAccessToken() {
            if (isStopped || isChecking) return;
            if (!hasStoredAccessToken()) {
                hasReportedFailure = false;
                return;
            }

            isChecking = true;
            try {
                // The shared helper coordinates refreshes with HTTP and WebSockets.
                await validAccess();
                hasReportedFailure = false;
            } catch (_) {
                reportRefreshFailure();
            } finally {
                isChecking = false;
            }
        }

        checkAccessToken();
        const intervalId = window.setInterval(checkAccessToken, checkIntervalMs);

        return function stopMonitoring() {
            isStopped = true;
            window.clearInterval(intervalId);
        };
    }, [checkIntervalMs]);
}

// Keep the existing AppLogout export for callers; access expiry now triggers refresh.
export default function AppLogout({ children, checkIntervalMs = DEFAULT_REFRESH_CHECK_INTERVAL_MS }) {
    const intervalMs = Number.isFinite(checkIntervalMs) && checkIntervalMs > 0
        ? checkIntervalMs
        : DEFAULT_REFRESH_CHECK_INTERVAL_MS;

    useAccessTokenRefreshMonitor(intervalMs);
    return children;
}


// // Previous access-expiry logout implementation.
// // import { useEffect } from "react";
// // import { useAuth } from "../auth-provider/auth-provider";
// //
// // const AppLogout = ({ children }) => {
// //     const auth = useAuth();
// //
// //     useEffect(() => {checkForTokenExpiration()},
// //     [])
// //
// //     const checkForTokenExpiration = () => {
// //         if(auth?.user){
// //             const expiration = auth?.user?.expiresIn;
// //             const now_is = new Date().getTime() / 1000;
// //             if (now_is > expiration){
// //                 auth.logout();
// //             }
// //         }
// //     }
// //
// //     return children;
// //   };
// //   export default AppLogout;
